export default __webpack_public_path__ + "static/media/25-min.0ae56d8b.png";